import { render, staticRenderFns } from "./NewMedicationForm.vue?vue&type=template&id=ff4ed196&scoped=true"
import script from "./NewMedicationForm.vue?vue&type=script&lang=js"
export * from "./NewMedicationForm.vue?vue&type=script&lang=js"
import style0 from "./NewMedicationForm.vue?vue&type=style&index=0&id=ff4ed196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4ed196",
  null
  
)

export default component.exports